import React from "react";
import ReactMarkdown from "react-markdown"
const Content = (props) => {
    return(
        <div className="wysiwyg-block">
        <ReactMarkdown source={props?.Content} allowDangerousHtml />
        </div>
    )
}
export default Content